export default "__VITE_PUBLIC_ASSET__a9070f5a__"